import { FirestorePostRepository } from '../posts/repositories/FirestorePostRepository';
import { FirestoreUserRepository } from '../users/repositories/FirestoreUserRepository';
import { FirestoreNotificationRepository } from '../notifications/repositories/FirestoreNotificationRepository';
import { LocalCategoryRepository } from '../categories/repositories/LocalCategoryRepository';
import { ApiAgentRepository } from '../agent/repositories/ApiAgentRepository';

export const repositories = {
  posts: new FirestorePostRepository(),
  users: new FirestoreUserRepository(),
  notifications: new FirestoreNotificationRepository(),
  categories: new LocalCategoryRepository(),
  agent: new ApiAgentRepository()
};
  
